import CustomText from 'components/common/CustomText/CustomText'
import React from 'react'
import { colors } from 'styles/colors';

interface Props {
    text?: string;
    content?: React.ReactNode;
}

export default function CustomCellValue({ text, content }: Props) {
    return (
        <>
        {text && <CustomText
            text={text}
            fontSize={15}
            fontWeight={500}
            color={colors.black}
        />}

        {content && content}
        </>
    )
}
